
const GoogleFormEmbed = () => {
  return (
    <div className="w-full h-full rounded-2xl overflow-hidden bg-bg-secondary">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSc1pbJM3miCe3ohy0ylmAPylPxCnBMX1hKs6crDmFlbHQFd4g/viewform?usp=publish-editor"
        title="Contact Google Form"
        className="w-full h-full border-0"
        loading="lazy"
      />
    </div>
  );
};



export default GoogleFormEmbed;
